<template>
 <div id="main_div">

   <!-- Home Section start-->
   <section id="home" class="home">
     <div class="home-decor">
       <div class="home-circle1"><img :src='"../assets/images/main-banner3.png"' alt=""></div>
       <div class="home-circle2"><img :src='"../assets/images/main-banner12.png"' alt=""></div>
       <div class="home-circle3"><img :src='"../assets/images/main-banner1.png"' alt=""></div>
     </div>
     <div class="container">
       <div class="row">
         <div class="col-md-5">
           <div class="home-contain">
             <div>
               <img :src='"../assets/images/logoimage.png"' alt="caption-img" style="width:200px;height:200px;" class="caption-img">
               <h1>
                 <span class="f-bold f-color">LiveTrackz</span>
               </h1>
               <p>Compliment Your Live Performances With Matching Drum and Percussion Loops.</p>
               <a href="https://apps.apple.com/us/app/livetrackz/id1469949984" target="_blank"><img :src='"../assets/images/appstore.png"' alt="appstore" class="store"></a>
             </div>
           </div>
         </div>
         <div class="col-sm-6 offset-md-1">
           <div class="home-right">
             <!-- Tile js start -->
             <Tile :image = '"mobile.png"'/>
             <!-- Tile js end -->
           </div>
         </div>
       </div>
     </div>
   </section>
   <!--Home Section End -->

   <!-- About Start  -->
   <About/>
   <!-- About End -->

   <!-- Feature Section start -->
   <Feature/>
   <!-- Feature Section End -->

   <!-- Screenshots Section Start -->
   <Screenshots/>
   <!-- Screenshots Section End -->

   <!-- Team Section Start -->
   <!-- <Team/> -->

   <!-- team Section End -->

   <!-- Price Section start-->
   <Price/>
   <!-- Price Section End -->

   <!-- Contact Section start -->
   <!-- <Contact_us/> -->
   <!-- Contact Section End -->

   <!--Map Section Start-->
   <Map/>
   <!--Map Section Ends-->

   <!-- Footer Section start -->
  <Footer/>
   <!-- Footer Section End -->

   <js/>

 </div>
</template>
<script>
export default {
  name: 'Home_one',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
  <!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->



// WEBPACK FOOTER //
// src/demo_page/home_one.vue